import React from 'react';

export const TowerIcon = ({ size = 40, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="towerGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1e5a7d', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#3b9fd8', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Left bar */}
      <rect
        x="15"
        y="25"
        width="18"
        height="50"
        rx="9"
        fill="url(#towerGradient)"
      />
      
      {/* Middle bar (taller - extends both up and down) */}
      <rect
        x="41"
        y="10"
        width="18"
        height="80"
        rx="9"
        fill="url(#towerGradient)"
      />
      
      {/* Right bar */}
      <rect
        x="67"
        y="25"
        width="18"
        height="50"
        rx="9"
        fill="url(#towerGradient)"
      />
    </svg>
  );
};
